import { setCookie, deleteCookie } from "@/libraries/VueMethods";
import cloneDeep from 'lodash/cloneDeep'



const state = {
    fullName: null,
};
const getters = {
   
};
const mutations = {
    // تابع ست کردن استاتوس برای لاگین بودن کاربر
    // این تابع در مانتد کامپوننت های هدر و رسپ لاگین ودال صدا زده میشود
    // این تابع به هنگام لوگ اوت با مقدار فالس صدا زده میشود
   
    setProfileImage(state, image) {
        let homeData = this.state.front[1].homeData;
        let userDetail = this.state.front[7].userDetail;
        let user = cloneDeep(homeData.user); // For reactivity
        user.user.image = image;
        homeData.user = user;

        userDetail.image = image;
    },
    // Set token in cookie and axios
    setToken(state, accessToken) {
        setCookie(
            "Authorization",
            `Bearer ${accessToken}`,
            365
        );
        this._vm.$axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    }

};
const actions = {
    async deleteAddress({ commit }, payLoad) {
        let id = payLoad.id
        let willDelete = await window.swal({
            title: "آدرس حذف شود؟",
            text: "این عملیات غیر قابل بازگشت خواهد بود",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: true,
            dangerMode: true,
            buttons: ["خیر", "بله حذف کن"],
        })

        if (willDelete) {
            return await this._vm.$axios.delete(`customer/addresses/${id}`)
        }
    },

};
export default {
    state,
    getters,
    mutations,
    actions
}
